import { ISessionStorage } from '../../domain/model/session.interface';
import { Session } from '../../domain/model/session.model';

export class SessionMapper {
  static fromStorage(storageSession: ISessionStorage): Session {
    return new Session(
      storageSession.drawer,
      storageSession.audit,
      storageSession.folder,
      storageSession.location,
      storageSession.terminal,
      storageSession.waiter
    );
  }

  static toStorage(session: Session): ISessionStorage {
    return {
      drawer: session.drawer,
      audit: session.audit,
      folder: session.folder,
      location: session.location,
      terminal: session.terminal,
      waiter: session.waiter
    };
  }

  static toEmpty(): Session {
    return new Session(null, null, null, null, null, null);
  }
}
